import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Grid,
  Button,
  Stack,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  alpha,
  useTheme,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faPeopleGroup,
  faPeopleRoof,
} from "@fortawesome/free-solid-svg-icons";
import CustomInput from "../../../../CustomForm/CustomInput";
import CustomTextArea from "../../../../CustomForm/CustomTextArea";
import CustomDate from "../../../../CustomForm/CustomDate";
import CommonButton from "../../../../CustomForm/CommonButton";
import CommunicationTable from "../../WhatElse/Communication/CommunicationTable";

const CommunicationNote = () => {
  const theme = useTheme();
  const [isActive, setIsActive] = useState(false);
  const [isActiveOne, setIsActiveOne] = useState(false);
  const [isActiveTwo, setIsActiveTwo] = useState(false);

  const handleClick = () => setIsActive(!isActive);
  const handleClickOne = () => setIsActiveOne(!isActiveOne);
  const handleClickTwo = () => setIsActiveTwo(!isActiveTwo);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Card */}
      <Card sx={{ mb: 3, borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <Box sx={{ p: 3, bgcolor: '#f8fafc', borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Typography variant="h5" fontWeight={700} color="#0f172a">
            Hamidabai Abdulaboobaker - Communication Note
          </Typography>
        </Box>
      </Card>

      {/* Add Communication Note Form */}
      <Card sx={{ mb: 4, borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" fontWeight={700} color="#1A1A2E" sx={{ mb: 3, pb: 2, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
            Add a Communication Note
          </Typography>

          <Grid container spacing={2}>
            {/* Name and Position */}
            <Grid item xs={12} md={6}>
              <CustomInput 
                label="Name*" 
                name="name" 
                placeholder="Enter name" 
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Position*</InputLabel>
                <Select
                  label="Position*"
                  defaultValue=""
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="1">Option 1</MenuItem>
                  <MenuItem value="2">Option 2</MenuItem>
                  <MenuItem value="3">Option 3</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Reason for Communication */}
            <Grid item xs={12}>
              <CustomInput
                label="Reason for communication *"
                name="communication"
                placeholder="Enter reason"
                fullWidth
              />
            </Grid>

            {/* Outcome */}
            <Grid item xs={12}>
              <CustomTextArea 
                label="Outcome*" 
                name="outcome" 
                rows={3}
                fullWidth
              />
            </Grid>

            {/* Signature */}
            <Grid item xs={12}>
              <CustomTextArea 
                label="Signature*" 
                name="signature" 
                rows={2}
                fullWidth
              />
            </Grid>

            {/* Date / Time */}
            <Grid item xs={12} md={6}>
              <CustomDate 
                label="Date / Time" 
                name="date_time" 
                fullWidth
              />
            </Grid>
          </Grid>

          {/* Private Note Toggle */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 3 }}>
            <Typography variant="body2" fontWeight={600} color="#1A1A2E">
              Private Note
            </Typography>
            <Switch size="medium" />
          </Box>

          {/* Share Options */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" fontWeight={600} color="#1A1A2E" sx={{ mb: 2 }}>
              Share with:
            </Typography>
            <Stack direction="row" spacing={3} alignItems="center">
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant={isActive ? "contained" : "outlined"}
                  onClick={handleClick}
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    minWidth: 0,
                    bgcolor: isActive ? theme.palette.primary.main : 'transparent',
                    borderColor: isActive ? theme.palette.primary.main : alpha(theme.palette.divider, 0.3),
                    color: isActive ? '#fff' : '#64748b',
                    '&:hover': {
                      bgcolor: isActive ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.04),
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faHandshake} size="lg" />
                </Button>
                <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontWeight: 600, color: '#475467' }}>
                  Handover
                </Typography>
              </Box>

              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant={isActiveOne ? "contained" : "outlined"}
                  onClick={handleClickOne}
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    minWidth: 0,
                    bgcolor: isActiveOne ? theme.palette.primary.main : 'transparent',
                    borderColor: isActiveOne ? theme.palette.primary.main : alpha(theme.palette.divider, 0.3),
                    color: isActiveOne ? '#fff' : '#64748b',
                    '&:hover': {
                      bgcolor: isActiveOne ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.04),
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faPeopleRoof} size="lg" />
                </Button>
                <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontWeight: 600, color: '#475467' }}>
                  Manager
                </Typography>
              </Box>

              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant={isActiveTwo ? "contained" : "outlined"}
                  onClick={handleClickTwo}
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    minWidth: 0,
                    bgcolor: isActiveTwo ? theme.palette.primary.main : 'transparent',
                    borderColor: isActiveTwo ? theme.palette.primary.main : alpha(theme.palette.divider, 0.3),
                    color: isActiveTwo ? '#fff' : '#64748b',
                    '&:hover': {
                      bgcolor: isActiveTwo ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.04),
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faPeopleGroup} size="lg" />
                </Button>
                <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontWeight: 600, color: '#475467' }}>
                  Family
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Submit Button */}
          <Box sx={{ mt: 4 }}>
            <CommonButton />
          </Box>
        </Box>
      </Card>

      {/* Communication Table - Full width without redundant header */}
      <Card sx={{ borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <Box sx={{ p: 0 }}>
          <CommunicationTable />
        </Box>
      </Card>
    </Box>
  );
};

export default CommunicationNote;